"use client"

import { FormattedMessage } from "react-intl"

import { Box, P } from "@bullseye/components"

import { DiscoveryBadgeProps } from "."

export default function DiscoveryBadge({ children }: DiscoveryBadgeProps) {
  return (
    <Box className="relative inline-flex">
      <Box
        className="absolute -left-1 -top-3 z-10 items-center justify-center rounded-full"
        style={{
          backgroundColor: "#ffd179",
          paddingLeft: 6,
          paddingRight: 6,
          paddingTop: 3,
          paddingBottom: 3,
        }}
      >
        <P className="text-[13px] font-semibold leading-4 text-[#26222f]">
          <FormattedMessage id="filters.category.discovery.badge" />
        </P>
      </Box>
      {children}
    </Box>
  )
}
